import React, { useEffect, useState, useRef } from "react";
import style from './editModal2.module.scss';
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import {
    maxMargin, minMargin, priceIncrease, promotion, reactive, safePricing, hasIncreasePricePermission,
    serverDataFields, strategy, variantByBox, outOfRangeStrategy, strategyTitle, hasMaxPriceLimit
} from "../../../helpers/consts/variantEditModal"
import Input from "../../input/input";
import Button from "../../Button/button"
import Switch from "../../SelectionControls/Switch/Switch"
import Modal from "../../Modal/Modal"
import RadioButton from "../../SelectionControls/RadioButton/RadioButton"
import SimpleDropDown from "../../Dropdown/SimpleDropDown/DropDown"
import Tabel from "../../variantList/variantEditModalTabel/variantEditModalTabel"
import {
    CalcPrice, EditMultipleVariantModalCalc, EditSingleVariantModalCalc, getManyVariant,
    GetSingleVariant, CompleteProgressBar, GetProgressBar, GetChannelDefaultSetting, GetWalletSettings
} from "../../../actions/APIcalls"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma"
import Tooltip from "../../tooltip/tooltip"
import Toast from "../../Toast/Toast";
import Skeleton from '../../skeleton/skeleton'
import axios from "axios";

const EditModal = (props) => {
    const [serverData, setServerData] = useState({})
    const [errors, setErrors] = useState({})
    const [marginArray, setMarginArray] = useState([
        { name: "100", checked: false }, { name: "200", checked: false },
        { name: "300", checked: false }, { name: "400", checked: false },
        { name: "500", checked: false }, { name: "600", checked: false },
        { name: "700", checked: false }, { name: "800", checked: false },
        { name: "900", checked: false }, { name: "1000", checked: false },
        { name: "2000", checked: false }, { name: "5000", checked: false },
        { name: "10000", checked: false }, { name: "20000", checked: false },
        { name: "50000", checked: false }, { name: "100000", checked: false },
        { name: "500000", checked: false }, { name: "1000000", checked: false },
        { name: "2000000", checked: false }, { name: "3000000", checked: false }, { name: "4000000", checked: false },
        { name: "5000000", checked: false }, { name: "10000000", checked: false },
        { name: "50000000", checked: false }, { name: "100000000", checked: false },
    ])
    const [desiredSizeOfPriceIncrease, setDesiredSizeOfPriceIncrease] = useState({ text: "", selected: false })
    const [roundnessDigits, setRoundnessDigits] = useState([
        { name: 2, checked: false },
        { name: 3, checked: false },
        { name: 4, checked: false },
        { name: 5, checked: false },
        { name: 6, checked: false }
    ])
    const [modalTabel, setModalTabel] = useState({ open: false, showConfirmButton: false })
    const [promotionPercent, setPromotionPercent] = useState('')
    const [modalData, setModalData] = useState({})
    const [toast, setToast] = useState('')
    const [tab, setTab] = useState('primary')//primary, default, group
    const [loading, setLoading] = useState(false)
    const [variantSizeWarning, setVariantSizeWarning] = useState({
        variantHasSizeLoading: false,
        variantHasSize: '',
    })

    const tableRef = useRef()

    //lifeCycles*********************************

    useEffect(() => {
        if (props.list.length == 0 && props.show) {
            closeModal()
        } else {
            if (props.list && props.list.length == 1) {
                getSingleVariant()
            } else if (props.list.length > 1) {
                getManyCommision()
            }
        }

    }, [props.list])
    //handlers***********************************
    const radioHandeler = (e, value, tag, secoundTag) => {
        let data = serverData;
        data[tag] = secoundTag
        setServerData({ ...data })
    }

    const deleteDropdownOption = (tag) => {
        let data = { ...serverData };
        delete data[tag]
        setServerData({ ...data })
    }

    const setPromotionPrice = (e) => {
        let data = { ...serverData }
        data.promotionMinPrice = toEnglishNumber(e.target.value.toString().replaceAll(",", ""))
        setServerData({ ...data })
        let temp = Math.round(100 * (1 - toEnglishNumber(e.target.value.toString().replaceAll(",", "")) / modalData.resourcePrice))
        temp = (temp > 0 ? temp : 0)
        setPromotionPercent(temp)
    }
    const setPromtionPercentFunction = (e) => {
        if (toEnglishNumber(e.target.value) <= 100) {
            let temp = (100 - toEnglishNumber(e.target.value)) * modalData.resourcePrice / 100;
            temp = (temp > 0 ? temp : 0)
            setPromotionPercent(toEnglishNumber(e.target.value))
            let data = { ...serverData }
            data.promotionMinPrice = temp || temp == 0 ? temp : ''
            setServerData({ ...data })
        }
    }
    const arrowHandler = (type) => {
        if (serverData.changePricePromotion) {
            let value = (promotionPercent) || 0
            if (type === 'plus') {
                value = parseInt(value) + 1
            } else {
                value = parseInt(value) - 1
            }
            if ((value) <= 100 && value >= 0) {
                let temp = (100 - (value)) * modalData.resourcePrice / 100;
                temp = (temp > 0 ? temp : 0)
                setPromotionPercent((value))
                let data = { ...serverData }
                data.promotionMinPrice = temp || ''
                setServerData({ ...data })
            }
        }
    }
    const handleDropdown = (tag, item) => {
        if (tag == 'sizeOfPriceIncrease') {
            let array = [...marginArray];
            array.forEach(element => {
                element.checked = false
            })
            let index = -1
            index = array.findIndex(element => element.name === item.name)
            if (index == -1) {
                // allow desired sizeOfPriceIncrease
                let tmp = desiredSizeOfPriceIncrease
                tmp.selected = true
                setDesiredSizeOfPriceIncrease({ ...tmp })
            } else {
                array[index].checked = true;
                setMarginArray([...array])
            }
        }
        if (tag == 'roundnessDigits') {
            let array = [...roundnessDigits]
            array.forEach(element => {
                element.checked = false
            })
            let index = array.findIndex(element => element.name === item.name)
            array[index].checked = true;
            setRoundnessDigits([...array])
        }
        let data = serverData;
        data[tag] = item.name;
        setServerData({ ...data })
    }
    const closeModal = (type) => {
        setPromotionPercent('')
        setServerData({})
        setModalTabel({ open: false })
        setErrors({})
        setTab('primary')

        props.closeModal(type == 'submited' ? 'submited' : ' edit')
    }
    const inputHandler = (tag, value) => {
        let data = serverData;
        data[tag] = toEnglishNumber(value.target.value.toString().replaceAll(",", ""));
        if (Number(data[tag]) == data[tag] && data[tag] % 1 !== 0) {
            data[tag] = Number(data[tag])
            if (tag == 'specificPricingRange') {
                data[tag] = Number(data[tag]).toFixed(0)
                setToast('لطفا از وارد کردن اعداد اعشاری خودداری کنید.')
            }
        }
        if (tag == 'desiredSizeOfPriceIncrease') {
            let tmp = desiredSizeOfPriceIncrease
            tmp.text = toEnglishNumber(value.target.value.toString().replaceAll(",", ""));
            setDesiredSizeOfPriceIncrease({ ...tmp })
        }
        setServerData({ ...data })
    }
    const onBlurHandler = (tag, e) => {
        let tmp = serverData
        if (tag == 'specificPricingRange') {
            if (toEnglishNumber(serverData.specificPricingRange) > 60) {
                tmp.specificPricingRange = null
                setServerData({ ...tmp })
            }
        }
    }
    const checkFieldsContent = () => {
        let Errors = errors
        serverDataFields.forEach(item => {
            if (!serverData[item.tag]) {
                if (item.tag == 'sizeOfPriceIncrease' && serverData[item.tag] == 0 && serverData.pricingStrategy == 'equalToBoxWinner') {
                    // Don't return error
                    delete Errors[item.tag]
                } else {
                    Errors[item.tag] = item.error
                }
            } else {
                delete Errors[item.tag]
            }
        })
        setErrors({ ...Errors })
        if (Object.keys(errors).length === 0) {
            return true
        } else {
            return false
        }
    }
    //set data*************************************
    const sendDataToParent = (type) => {
        if (checkFieldsContent()) {
            let data = { ...serverData }
            data['DKCommission'] = modalData.comission
            data['platformPercent'] = serverData.platformCosts && typeof modalData.platformPercent != 'undefined' ? modalData.platformPercent : 0
            if (!data.ancillaryCosts || typeof data.ancillaryCosts === "undefined") {
                data.ancillaryCosts = 0
            }
            if (data['safePricing'] == 'enable') {
                data.safePricing = true
            } else {
                data.safePricing = false
            }
            if (data.specificPricingRange) {
                data.specificPricingRange = Number(data.specificPricingRange)
            } else {
                data.specificPricingRange = null
            }
            if (!data.sellStatus || typeof data.sellStatus === "undefined") {
                data.sellStatus = false
            }
            if (type === "single") {
                data.variantId = props.list[0]._id
                data.isVariantBox = (data.variantByBoxType == 'variantBox' ? true : false)
            } else {
                let array = []
                props.list.forEach(item => {
                    array.push(item._id)
                })
                data.variantIds = array
            }
            if (data.pricingStrategy == "equalToBoxWinner") {
                data.pricingStrategy = "lowestPrice"
                data.sizeOfPriceIncrease = 0
            }
            if (data.sizeOfPriceIncrease == "مقدار دلخواه") {
                data.sizeOfPriceIncrease = desiredSizeOfPriceIncrease.text
            }
            editVariant(data, type)
        }
    }

    const editVariant = async (data, type) => {
        if (type === "single") {
            let res = await EditSingleVariantModalCalc(data, openToast)
            if (res) {
                closeModal('submited')
                let array = marginArray
                array.forEach(i => i.checked = false)
                setMarginArray([...array])
                let tabel = modalTabel
                tabel.open = false
                setModalTabel({ ...tabel })

                // complete progressBar
                await handleProgressBar()
                // complete progressBar
            }
        } else {
            let res = await EditMultipleVariantModalCalc(data, openToast)
            if (res) {
                closeModal('submited')
                let array = marginArray
                array.forEach(i => i.checked = false)
                setMarginArray([...array])
                let tabel = modalTabel
                tabel.open = false
                setModalTabel({ ...tabel })
            }
        }
    }

    const handleProgressBar = async () => {
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.AddRobot) {
                    await CompleteProgressBar({ stage: 'AddRobot' })
                }
            }
        }
    }

    const [calculateLoading, setCalculateLoading] = useState(false)

    const calculatePrice = async () => {
        if (validator()) {
            setCalculateLoading(true)
            let reqData = {
                ...serverData,
                ancillaryCosts: Number(serverData.ancillaryCosts),
                specificPricingRange: serverData.specificPricingRange ? Number(serverData.specificPricingRange) : null,
                isVariantBox: (serverData.variantByBoxType == 'variantBox' ? true : false),
                variantId: modalData._id,
                DKCommission: modalData.commission,
                platformPercent: serverData.platformCosts && typeof modalData.platformPercent != 'undefined' ? modalData.platformPercent : 0,
                pricingStrategy: (serverData.pricingStrategy == 'equalToBoxWinner' ? 'lowestPrice' : serverData.pricingStrategy),
                sizeOfPriceIncrease: (serverData.pricingStrategy == 'equalToBoxWinner' ? 0 : (desiredSizeOfPriceIncrease.text != '' ? desiredSizeOfPriceIncrease.text : serverData.sizeOfPriceIncrease)),
                safePricing: (serverData.safePricing == 'disable' ? false : true)
            }
            const res = await CalcPrice(reqData, openToast)
            if (res && res.data && res.data.success) {
                let Tabel = { ...modalTabel };
                Tabel.open = true
                Tabel.data = res.data.price.data
                if (serverData.platformCosts && res.data.price.data.minProfit.sellPrice2 && res.data.price.data.maxProfit.sellPrice2) {
                    Tabel.data.minProfit.sellPrice = res.data.price.data.minProfit.sellPrice2
                    Tabel.data.maxProfit.sellPrice = res.data.price.data.maxProfit.sellPrice2
                }
                Tabel.showConfirmButton = true
                setModalTabel({ ...Tabel })
            }
            setCalculateLoading(false)
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }
    const openToast = (error) => {
        setToast(error)
    }
    //getData**************************************
    const getManyCommision = async () => {
        let temp = []
        props.list.forEach(item => temp.push(item.productGroup))
        let res = await getManyVariant(temp)
        if (res) {
            let data = { ...serverData }
            res.data.minCommission === res.data.maxinCommission ?
                data.commission = res.data.minCommission :
                data.commission = `%${res.data.minCommission} - %${res.data.maxinCommission}`
            setServerData({ ...data })
        }
    }
    const getSingleVariant = async () => {
        setLoading(true)
        let res = await GetSingleVariant(props.list[0]._id, openToast);
        let defaultPricingRange = await GetWalletSettings({ accountId: props.accountId })
        if (res) {
            if (res.robot) {
                let data = { ...res.robot }
                if (data['changePricePromotion']) {
                    data['changePricePromotion'] = 'true'
                    let temp = Math.round(100 * (1 - (res.robot.promotionMinPrice / res.resourcePrice)))
                    temp = (temp > 0 ? temp : 0)
                    setPromotionPercent(temp)
                } else {
                    data['changePricePromotion'] = 'false'
                    data['promotionMinPrice'] = ''
                }

                if (data['isVariantBox']) {
                    data.variantByBoxType = 'variantBox'
                } else {
                    data.variantByBoxType = 'productBox'
                }

                if (data['pricingStrategy'] == "lowestPrice" && data['sizeOfPriceIncrease'] == 0) {
                    data.pricingStrategy = 'equalToBoxWinner'
                }
                if (typeof res.specificPricingRange != 'undefined') {
                    data.specificPricingRange = res.specificPricingRange
                }

                if (typeof data['safePricing'] != 'undefined') {
                    if (data['safePricing'] == true) {
                        data.safePricing = "enable"
                    } else {
                        data.safePricing = "disable"
                    }
                } else {
                    data.safePricing = "enable"
                }

                if (typeof data['outOfRangeStrategy'] == 'undefined') {
                    data.outOfRangeStrategy = "off"
                }
                if (typeof data['hasIncreasePricePermission'] == 'undefined') {
                    data.hasIncreasePricePermission = "off"
                } else {
                    if (data['hasIncreasePricePermission'] == false) {
                        data.hasIncreasePricePermission = "off"
                    }
                    if (data['hasIncreasePricePermission'] == true) {
                        data.hasIncreasePricePermission = "maxPrice"
                    }
                }
                if (typeof data['roundnessDigits'] == 'undefined') {
                    data.roundnessDigits = 2
                }
                if (typeof data['hasMaxPriceLimit'] == 'undefined') {
                    data.hasMaxPriceLimit = false
                }

                if (typeof data['platformCosts'] == 'undefined') {
                    data.platformCosts = false
                }

                setServerData({ ...data })
            } else {
                // if doesn't have robot
                let defaultSetting = {
                    pricingStrategy: "aiSmart",
                    ancillaryCosts: "0",
                    priceIncrease: !res.resourcePrice ? "maximumProfit" : "free",
                    reactivation: "enable",
                    salesStatus: true,
                    changePricePromotion: 'false',
                    sizeOfPriceIncrease: '1000',
                    roundnessDigits: 2,
                    maximumProfitMarginType: 'percent',
                    maximumProfitMargin: '1000',
                    promotionMinPrice: '',
                    variantByBoxType: 'variantBox',
                    safePricing: 'enable',
                    outOfRangeStrategy: "off",
                    hasIncreasePricePermission: 'off',
                    hasMaxPriceLimit: false,
                    platformCosts: false,
                    specificPricingRange: typeof res.specificPricingRange != 'undefined' ? res.specificPricingRange : '',
                    isVariantBox: true
                }
                let setting = await GetChannelDefaultSetting({ channel_id: res.channel })
                if (typeof setting !== "undefined" && typeof setting.data !== "undefined" && setting.data.data) {
                    defaultSetting = {
                        ...setting.data.data,
                        variantByBoxType: (typeof setting.data.data.isVariantBox !== "undefined") ? (setting.data.data.isVariantBox ? "variantBox" : "productBox") : "variantBox",
                        safePricing: (typeof setting.data.data.safePricing !== "undefined") ? (setting.data.data.safePricing ? "enable" : "disable") : "enable",
                        changePricePromotion: (typeof setting.data.data.changePricePromotion !== "undefined") ? (setting.data.data.changePricePromotion ? "true" : "false") : "false",
                        hasMaxPriceLimit: (typeof setting.data.data.hasMaxPriceLimit !== "undefined") ? setting.data.data.hasMaxPriceLimit : false,
                        platformCosts: (typeof setting.data.data.platformCosts !== "undefined") ? setting.data.data.platformCosts : false,
                    }
                }
                setServerData({ ...defaultSetting })
                setPromotionPercent('')
                let tempArr = marginArray
                tempArr[9].checked = true
                setMarginArray(tempArr)
            }
            res.defaultPricingRange = defaultPricingRange.data.currentPricingRange ? defaultPricingRange.data.currentPricingRange : 0
            setModalData({ ...res })
        }
        setLoading(false)
        // checkIfVariantHasSize(res.DKP)
    }

    const checkIfVariantHasSize = async (dkp) => {
        let tmp = variantSizeWarning
        tmp.variantHasSizeLoading = true
        setVariantSizeWarning({ ...tmp })
        await axios.get(`https://api.digikala.com/v1/product/${dkp}/`)
            .then(res => {
                if (res && res.data && res.data.status == 200 && res.data.data.product.variants &&
                    res.data.data.product.variants.length > 0 && res.data.data.product.variants[0].size) {
                    tmp.variantHasSize = 'در صورتی که تنوع شما دارای سایزبندی‌های مختلف و قیمت مرجع یکسان است، به دلیل احتمال محاسبه اشتباه قیمت مرجع از سمت دیجی‌کالا، فیلد افزایش قیمت را بر روی "محدود به حداکثر سود" و فیلد رقابت را بر روی "تنوع" انتخاب نمایید.'
                    setVariantSizeWarning({ ...tmp })
                } else {
                    tmp.variantHasSize = ''
                    setVariantSizeWarning({ ...tmp })
                }
            })
            .catch(err => {
                tmp.variantHasSize = ''
                setVariantSizeWarning({ ...tmp })
            })
        tmp.variantHasSizeLoading = false
        setVariantSizeWarning({ ...tmp })
    }
    //renderers************************************
    const placeholderRenderer = (tag) => {
        switch (serverData[tag]) {
            case "percent":
                return "درصد را وارد کنید"
            case "price":
                return "مبلغ را وارد کنید"
            case "minPrice":
                return "حداقل قیمت فروش را وارد کنید"
            case "maxPrice":
                return "ابتدا نوع حاشیه سود را تعیین کنید"
            default:
                return "ابتدا نوع حاشیه را تعیین کنید"

        }
    }

    //FUNCTION***********************************************************
    const validator = async () => {
        const checkList = ["ancillaryCosts", "maximumProfitMargin", "maximumProfitMarginType", "minimumProfitMargin", "minimumProfitMarginType", "priceIncrease",
            "pricingStrategy", "purchasePrice", "reactivation", "salesStatus", "sizeOfPriceIncrease", "safePricing", "hasIncreasePricePermission", "outOfRangeStrategy"];
        const errorList = {
            ancillaryCosts: "هزینه‌های جانبی را وارد کنید!",
            maximumProfitMargin: "حداکثر حاشیه سود را وارد کنید!",
            maximumProfitMarginType: "حداکثر حاشیه سود را وارد کنید!",
            minimumProfitMargin: "حداقل حاشیه سود را وارد کنید!",
            minimumProfitMarginType: "حداقل حاشیه سود را وارد کنید!",
            priceIncrease: "نوع افزایش قیمت را وارد کنید!",
            pricingStrategy: "نوع استراتژی را وارد کنید!",
            purchasePrice: "قیمت خرید را وارد کنید!",
            reactivation: "نوع فعال‌سازی مجدد را وارد کنید!",
            safePricing: "نوع افزایش قیمت امن را وارد کنید",
            hasIncreasePricePermission: "نوع استراتژی کف قیمت را مشخص کنید",
            outOfRangeStrategy: "نوع استراتژی خارج از بازه را مشخص کنید.",
            sizeOfPriceIncrease: "پله تغییر قیمت را وارد کنید!",
        }
        let editVaraintTemp = { ...serverData }
        let errs = { ...errors };
        await checkList.map(property => {
            if (typeof (editVaraintTemp) === "undefined" || typeof editVaraintTemp[property] === "undefined") {
                errs[property] = errorList[property];
            } else {
                delete errs[property];
            }
        })
        setErrors({ ...errs })
        return Object.keys(errors).length === 0 ? true : false;
    }

    const modalContentGenerator = () => {
        switch (tab) {
            case 'primary':
                return <React.Fragment>
                    <div className={style.purchasePrice}>
                        <div className={style.inputWrapperPrice}>
                            <Input
                                type="text"
                                disabled={false}
                                label="قیمت خرید"
                                withRial={true}
                                placeholder="قیمت خرید را وارد کنید"
                                error={typeof errors["purchasePrice"] !== "undefined" && errors["purchasePrice"]}
                                tag="purchasePrice"
                                value={serverData.purchasePrice ? numberWithCommas(serverData.purchasePrice) : ""}
                                onchange={inputHandler}
                                onblur={onBlurHandler}
                            />
                        </div>

                        <div className={style.row2}>
                            <p>حداقل حاشیه سود</p>
                        </div>
                        <div className={style.col}>
                            <div className={style.minProfitRow}>
                                {minMargin.map((item, index) => {
                                    return <div className={style.radioWrapper} key={index}>
                                        <div className={style.RadioButton}>
                                            <RadioButton
                                                key={"min" + index}
                                                value={serverData.minimumProfitMarginType === item.value ? true : false}
                                                disabled={false}
                                                tag={"minimumProfitMarginType"}
                                                secondTag={item.value}
                                                label={item.label}
                                                onclick={radioHandeler}
                                            /></div>
                                    </div>

                                })}
                                <div className={style.inputWrapper}>
                                    <Input
                                        type="text"
                                        disabled={typeof serverData.minimumProfitMarginType !== "undefined" ? false : true}
                                        placeholder={placeholderRenderer("minimumProfitMarginType")}
                                        tag="minimumProfitMargin"
                                        value={typeof serverData.minimumProfitMargin !== "undefined" ? numberWithCommas(serverData.minimumProfitMargin) : ""}
                                        error={typeof errors["minimumProfitMargin"] !== "undefined" && errors["minimumProfitMargin"]}
                                        withRial={typeof serverData.minimumProfitMarginType !== " undefined" && serverData.minimumProfitMarginType !== "percent"}
                                        withPercent={typeof serverData.minimumProfitMarginType !== " undefined" && serverData.minimumProfitMarginType == "percent"}
                                        onchange={inputHandler}
                                        onblur={onBlurHandler}
                                    />
                                </div>
                            </div>
                            <div className={style.errorWrapper}>
                                {/* <span>{errors["minimumProfitMargin"]}</span> */}
                            </div>
                        </div>


                        <div className={style.row2}>
                            <p className={style.title}>افزایش قیمت</p>
                        </div>
                        <div className={style.col}>
                            <div className={style.row}>
                                {priceIncrease.map((item, index) => {
                                    return <div className={style.radioWrapper} key={"pInc" + index}>
                                        <div className={style.RadioButton} key={"pInc" + index}>
                                            <RadioButton
                                                value={serverData.priceIncrease === item.value ? true : false}
                                                disabled={false}
                                                tag={"priceIncrease"}
                                                secondTag={item.value}
                                                label={item.label}
                                                onclick={radioHandeler}
                                            /></div>
                                    </div>

                                })}

                            </div>
                            <div className={style.errorWrapper}>
                                <span>{errors["priceIncrease"]}</span>
                            </div>
                        </div>

                        <div className={style.strategyWrapper}>
                            <div className={style.row2} style={(typeof serverData.maximumProfitMarginType == "undefined") || (serverData.priceIncrease == 'free' || serverData.priceIncrease == 'referencePrice') ? { opacity: '0.45' } : null}>
                                <p className={style.title}>حداکثر حاشیه سود</p>
                            </div>
                            <div className={style.col}>
                                <div className={style.row}>
                                    <div className={`${style.row} ${style.responsiveRow}`} style={(typeof serverData.maximumProfitMarginType == "undefined") || (serverData.priceIncrease == 'free' || serverData.priceIncrease == 'referencePrice') ? { opacity: '0.45', marginBottom: '0' } : { marginBottom: '0' }}>
                                        {maxMargin.map((item, index) => {
                                            return <div className={style.radioWrapper} key={index}>
                                                <div className={style.RadioButton}>
                                                    <RadioButton
                                                        value={serverData.maximumProfitMarginType === item.value ? true : false}
                                                        disabled={(typeof serverData.maximumProfitMarginType == "undefined") || (serverData.priceIncrease == 'free' || serverData.priceIncrease == 'referencePrice') ? true : false}
                                                        tag={"maximumProfitMarginType"}
                                                        label={item.label}
                                                        secondTag={item.value}
                                                        onclick={radioHandeler}
                                                        key={"min" + index}
                                                    />
                                                </div>
                                            </div>

                                        })}
                                        <div className={style.inputWrapper}>
                                            <Input
                                                type="text"
                                                disabled={(typeof serverData.maximumProfitMarginType == "undefined") || (serverData.priceIncrease == 'free' || serverData.priceIncrease == 'referencePrice') ? true : false}
                                                placeholder={placeholderRenderer('maximumProfitMarginType')}
                                                tag="maximumProfitMargin"
                                                value={(typeof serverData.maximumProfitMargin !== "undefined") && (serverData.priceIncrease !== 'free' && serverData.priceIncrease !== 'referencePrice') ? numberWithCommas(serverData.maximumProfitMargin) : ""}
                                                // error={editModal.maxMarginErr ? "" : ""}
                                                withRial={typeof serverData.maximumProfitMarginType !== " undefined" && serverData.maximumProfitMarginType !== "percent"}
                                                withPercent={typeof serverData.maximumProfitMarginType !== " undefined" && serverData.maximumProfitMarginType == "percent"}
                                                onchange={inputHandler}
                                                onblur={onBlurHandler}
                                            />
                                        </div>
                                    </div>
                                    <div className={style.infoBar}>
                                        <p className={style.text}>در صورت انتخاب افزایش قیمت “آزاد(بیشترین قیمت ممکن)” و “محدود به قیمت مرجع”، تغییر حداکثر حاشیه سود امکان‌پذیر نیست.</p>
                                        <span className={style.infoIcon}>h</span>
                                    </div>
                                </div>
                                <div className={style.errorWrapper}>
                                    <span>{errors["maximumProfitMargin"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            case 'default':
                return <React.Fragment>
                    <div className={style.row}>
                        <div className={style.sellStat}>
                            <Switch
                                value={typeof serverData.salesStatus !== "undefined" && serverData.salesStatus ? true : false}
                                indeterminate={false}
                                disabled={false}
                                tag='salesStatus'
                                label='وضعیت ربات'
                                onclick={(e, val, tag) => {
                                    let data = serverData;
                                    data[tag] = !val;
                                    setServerData({ ...data })
                                }}
                            />
                        </div>
                    </div>

                    <div className={style.row}>
                        <div className={style.purchasePrice}>
                            <div className={style.row2}>
                                <p className={style.title}>رقابت</p>
                            </div>
                            <div className={style.col}>
                                <div className={style.row}>
                                    {variantByBox.map((item, index) => {
                                        return <div className={style.radioWrapper} key={index}>
                                            <div className={style.RadioButton}>
                                                <RadioButton
                                                    value={serverData.variantByBoxType === item.value ? true : false}
                                                    disabled={false}
                                                    tag={"variantByBoxType"}
                                                    label={item.label}
                                                    secondTag={item.value}
                                                    onclick={radioHandeler}
                                                    key={"variantByBox" + index}
                                                />
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>

                            {/*Strategy*/}
                            <div className={style.strategyWrapper}>
                                <div className={style.row2}>
                                    <p className={style.title}>استراتژی</p>
                                </div>
                                <div className={style.col}>
                                    <div className={style.row}>
                                        {strategy.map((item, index) => {
                                            return <div className={style.radioWrapper} key={"stg" + index}>
                                                <div className={style.RadioButton}>
                                                    <RadioButton
                                                        value={serverData.pricingStrategy === item.value ? true : false}
                                                        disabled={false}
                                                        tag={"pricingStrategy"}
                                                        label={item.label}
                                                        secondTag={item.value}
                                                        onclick={radioHandeler}
                                                    /></div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={style.errorWrapper}>
                                <span>{errors["pricingStrategy"]}</span>
                            </div>
                            {/*Strategy*/}
                            {serverData.pricingStrategy == 'aiSmart' ? <div className={style.strategyWrapper}>
                                <div className={style.row2}>
                                    <p className={style.title}>حفظ پله در افزایش قیمت</p>
                                    <div className={style.iconWrapper}>
                                        <Tooltip
                                            direction='Left'
                                            text='با فعال‌سازی این گزینه قیمت محصول تنها به اندازه یک پله بالاتر از رقیب‌تان افزایش می‌یابد'
                                        />
                                    </div>
                                </div>
                                <div className={style.col}>
                                    <div className={style.row}>
                                        {hasMaxPriceLimit.map((item, index) => {
                                            return <div className={style.radioWrapper} key={"hasMaxPriceLimit" + index}>
                                                <div className={style.RadioButton}>
                                                    <RadioButton
                                                        value={serverData.hasMaxPriceLimit === item.value ? true : false}
                                                        disabled={false}
                                                        tag={"hasMaxPriceLimit"}
                                                        label={item.label}
                                                        secondTag={item.value}
                                                        onclick={radioHandeler}
                                                    /></div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                                :
                                <></>
                            }

                            <div className={style.col}>
                                <div className={style.rowAxillary}>
                                    {(serverData.pricingStrategy == 'lowestPrice' || serverData.pricingStrategy == 'boxStep' || (serverData.pricingStrategy == 'aiSmart' && serverData.hasMaxPriceLimit)) ? <>
                                        {desiredSizeOfPriceIncrease.selected && <div className={style.inputWrapper}>
                                            <Input
                                                type="text"
                                                label="پله تغییر قیمت دلخواه"
                                                disabled={false}
                                                placeholder="پله تغییر قیمت دلخواه"
                                                tag="desiredSizeOfPriceIncrease"
                                                value={typeof desiredSizeOfPriceIncrease.text !== "undefined" ? numberWithCommas(desiredSizeOfPriceIncrease.text.toString()) : "0"}
                                                withRial={true}
                                                onchange={inputHandler}
                                                onblur={onBlurHandler}
                                            />
                                        </div>}
                                        <div className={style.dropdownWrap}>
                                            <SimpleDropDown
                                                tag='sizeOfPriceIncrease'
                                                label='پله تغییر قیمت'
                                                // placeHolder={serverData.sizeOfPriceIncrease && toPersianNumber(serverData.sizeOfPriceIncrease)}
                                                fixedOptions={[{ name: "مقدار دلخواه", checked: false }]}
                                                value={serverData.sizeOfPriceIncrease && toPersianNumber(numberWithCommas(serverData.sizeOfPriceIncrease))}
                                                dropdownList={marginArray}
                                                hasSearchBox={false}
                                                hasCheckbox={false}
                                                handleSelect={handleDropdown}
                                                deleteSelectedItems={deleteDropdownOption}
                                                withRial={true}
                                                withCommas={true}
                                                errorMessage=''
                                            />
                                            <div className={style.errorWrapper}>
                                                <span>{errors["sizeOfPriceIncrease"]}</span>
                                            </div>
                                        </div>
                                    </>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={style.pricingStrategyContainer}>
                        {/* Here was the strategy.... */}
                        <div className={style.promotionSection}>
                            <p className={style.mainTitle}>استراتژی کف قیمت: </p>
                            <div className={style.subTitleRow}>
                                <p className={style.subTitle}>{strategyTitle.hasIncreasePricePermission[serverData.pricingStrategy] ? strategyTitle.hasIncreasePricePermission[serverData.pricingStrategy] : 'استراتژی کف قیمت'}</p>
                                <p className={style.subTitle}>ربات....</p>
                            </div>
                            <div className={style.col}>
                                <div className={style.row}>
                                    {hasIncreasePricePermission.map((item, index) => {
                                        return <div className={style.radioWrapper} key={"hasIncreasePricePermission" + index}>
                                            <div className={style.RadioButton}>
                                                <RadioButton
                                                    value={serverData.hasIncreasePricePermission === item.value ? true : false}
                                                    disabled={false}
                                                    tag={"hasIncreasePricePermission"}
                                                    secondTag={item.value}
                                                    label={item.label}
                                                    onclick={radioHandeler}
                                                /></div>
                                        </div>

                                    })}
                                </div>
                                <div className={style.errorWrapper}>
                                    <span>{errors["hasIncreasePricePermission"]}</span>
                                </div>
                            </div>
                        </div>

                        <div className={style.gap} style={{ height: '40px' }}></div>

                        <div className={style.promotionSection}>
                            <p className={style.mainTitle}>استراتژی خارج از بازه: </p>
                            <div className={style.subTitleRow}>
                                <p className={style.subTitle}>{strategyTitle.outOfRangeStrategy ? strategyTitle.outOfRangeStrategy : 'استراتژی خارج از بازه'}</p>
                                <p className={style.subTitle}>ربات....</p>
                            </div>
                            <div className={style.col}>
                                <div className={style.row}>
                                    {outOfRangeStrategy.map((item, index) => {
                                        return <div className={style.radioWrapper} key={"outOfRangeStrategy" + index}>
                                            <div className={style.RadioButton}>
                                                <RadioButton
                                                    value={serverData.outOfRangeStrategy === item.value ? true : false}
                                                    disabled={false}
                                                    tag={"outOfRangeStrategy"}
                                                    secondTag={item.value}
                                                    label={item.label}
                                                    onclick={radioHandeler}
                                                /></div>
                                        </div>

                                    })}
                                </div>
                                <div className={style.errorWrapper}>
                                    <span>{errors["outOfRangeStrategy"]}</span>
                                </div>
                            </div>
                        </div>

                        <div className={style.gap} style={{ height: '40px' }}></div>

                        <div>
                            {/* Here was the max price.... */}
                            <div className={style.promotionSection}>
                                <div className={style.row}>
                                    <div className={style.title}>افزایش قیمت امن</div>
                                    <div className={style.iconWrapper}>
                                        <Tooltip
                                            direction='Left'
                                            text='با فعال‌سازی این گزینه، در صورتی که رقیبی برای تنوع شما وجود نداشته باشد، افزایش قیمت تا اندازه‌ای صورت می‌گیرد که باعث اخطار گران‌فروشی نشود.'
                                        />
                                    </div>
                                </div>
                                <div className={style.col}>
                                    <div className={style.row}>
                                        {safePricing.map((item, index) => {
                                            return <div className={style.radioWrapper} key={"safePricing" + index}>
                                                <div className={style.RadioButton}>
                                                    <RadioButton
                                                        value={serverData.safePricing === item.value ? true : false}
                                                        disabled={false}
                                                        tag={"safePricing"}
                                                        secondTag={item.value}
                                                        label={item.label}
                                                        onclick={radioHandeler}
                                                    /></div>
                                            </div>

                                        })}
                                    </div>
                                    <div className={style.errorWrapper}>
                                        <span>{errors["safePricing"]}</span>
                                    </div>
                                </div>
                            </div>

                            <div className={style.gap} style={{ height: '40px' }}></div>

                            <div className={style.row2}>
                                <p className={style.title}>فعال‌سازی مجدد</p>
                            </div>
                            <div className={style.gap} style={{ height: '10.5px' }}></div>
                            <div className={style.col}>
                                <div className={style.row}>
                                    {reactive.map((item, index) => {
                                        return <div className={style.radioWrapper} key={"reacrive" + index}>
                                            <div className={style.RadioButton}>
                                                <RadioButton
                                                    value={serverData.reactivation === item.value ? true : false}
                                                    disabled={false}
                                                    tag={"reactivation"}
                                                    secondTag={item.value}
                                                    label={item.label}
                                                    onclick={radioHandeler}
                                                /></div>
                                        </div>

                                    })}
                                </div>
                                <div className={style.errorWrapper}>
                                    <span>{errors["reactivation"]}</span>
                                </div>
                            </div>

                            <div className={style.ancillaryCostsWrapper}>
                                <div className={style.inputWrapper}>
                                    <Input
                                        type="text"
                                        label="هزینه‌های جانبی"
                                        disabled={false}
                                        placeholder="هزینه‌های جانبی"
                                        tag="ancillaryCosts"
                                        value={typeof serverData.ancillaryCosts !== "undefined" ? numberWithCommas(serverData.ancillaryCosts.toString()) : "0"}
                                        withRial={true}
                                        onchange={inputHandler}
                                        onblur={onBlurHandler}
                                    />
                                </div>
                            </div>
                            <div className={style.gap} style={{ height: '40px' }}></div>

                            <div className={style.timeRangeWrapper}>
                                <div className={style.timeRange}>
                                    <Input
                                        type="text"
                                        label="بازه‌ی قیمت‌گذاری دلخواه (دقیقه)"
                                        disabled={false}
                                        placeholder={`بازه قیمت‌گذاری پیش‌فرض: ${toPersianNumber(modalData.defaultPricingRange)}`}
                                        tag="specificPricingRange"
                                        value={typeof serverData.specificPricingRange !== "undefined" && serverData.specificPricingRange !== null ? numberWithCommas(serverData.specificPricingRange.toString()) : ""}
                                        withMinute={true}
                                        onchange={inputHandler}
                                        onblur={onBlurHandler}
                                    />
                                </div>

                                <div className={style.timeRange}>
                                    <SimpleDropDown
                                        tag='roundnessDigits'
                                        label='ارقام رند'
                                        value={serverData.roundnessDigits && toPersianNumber(numberWithCommas(serverData.roundnessDigits))}
                                        dropdownList={roundnessDigits}
                                        hasSearchBox={false}
                                        hasCheckbox={false}
                                        handleSelect={handleDropdown}
                                        deleteSelectedItems={deleteDropdownOption}
                                        withRial={false}
                                        withCommas={false}
                                        errorMessage=''
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* platformCosts */}
                    <div className={style.row}>
                        <div className={style.sellStat}>
                            <Switch
                                value={typeof serverData.platformCosts !== "undefined" && serverData.platformCosts ? true : false}
                                indeterminate={false}
                                disabled={false}
                                tag='platformCosts'
                                label='درنظر گرفتن فروش اعتباری'
                                onclick={(e, val, tag) => {
                                    let data = serverData;
                                    data[tag] = !val;
                                    setServerData({ ...data })
                                }}
                            />
                        </div>
                    </div>
                    {/* platformCosts */}

                    <div className={style.promotionSection}>
                        <div className={style.row}>
                            <div className={style.title}>تخفیف هوشمند</div>
                            <div className={style.iconWrapper}>
                                <Tooltip
                                    direction='Left'
                                    text='در صورت تمایل می‌توانید قیمت‌گذاری توسط ربات را برای تنوع‌های موجود در پروموشن نیز فعال کنید.'
                                />
                            </div>
                        </div>
                        <div className={style.col}>
                            <div className={style.row}>
                                {promotion.map((item, index) => {
                                    return <div className={style.radioWrapper} key={"promotion" + index}>
                                        <div className={style.RadioButton}>
                                            <RadioButton
                                                value={serverData.changePricePromotion && serverData.changePricePromotion.toString() == item.value ? true : false}
                                                disabled={false}
                                                tag={"changePricePromotion"}
                                                secondTag={item.value}
                                                label={item.label}
                                                onclick={radioHandeler}
                                            /></div>
                                    </div>
                                })}
                            </div>
                            <div className={style.errorWrapper}>
                                {/* <span>{errors["sellingType"]}</span> */}
                            </div>
                        </div>
                        <div className={style.promotionInputsRow}>

                            <div className={style.col}>
                                <div className={style.col}>
                                    <div
                                        className={serverData.changePricePromotion === 'true' ? style.label : style.disabledLabel}>
                                        حداقل مبلغ فروش در تخفیف هوشمند
                                    </div>
                                    <div className={style.inputContainer}>
                                        <div className={style.inputWrap}>
                                            <input
                                                placeholder="مبلغ را وارد کنید"
                                                className={style.fullInput}
                                                disabled={serverData['changePricePromotion'] === 'true' ? false : true}
                                                value={typeof serverData.promotionMinPrice !== "undefined" && serverData.promotionMinPrice ? toPersianNumber(numberWithCommas(parseInt(serverData.promotionMinPrice))) : toPersianNumber(numberWithCommas(parseInt(0)))}
                                                onChange={(e) => setPromotionPrice(e)} />
                                            <span>ریال</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={serverData.changePricePromotion ? style.text : style.disabledText}>(معادل)
                            </div>
                            <div className={style.col}>
                                <div
                                    className={serverData['changePricePromotion'] === 'true' ? style.label : style.disabledLabel}>
                                    حداکثر درصد تخفیف در تخفیف هوشمند
                                </div>
                                <div
                                    className={serverData.changePricePromotion === 'true' ? style.inputContainer : style.disabledInputContainer}>
                                    <div className={style.arrowButtonPack}>
                                        <div className={style.top} onClick={() => {
                                            serverData.changePricePromotion === 'true' && arrowHandler('plus')
                                        }} disabled={serverData.changePricePromotion === 'true' ? false : true}>
                                            <div className={style.arrowUp}>c</div>
                                        </div>
                                        <div className={style.bottom} onClick={() => {
                                            serverData.changePricePromotion === 'true' && arrowHandler('minus')
                                        }} disabled={serverData.changePricePromotion === 'true' ? false : true}>
                                            <div className={style.arrowDown}>c</div>
                                        </div>

                                    </div>
                                    <div className={style.inputWrap}>
                                        <input
                                            placeholder="درصد را وارد کنید"
                                            className={style.input}
                                            disabled={serverData['changePricePromotion'] == 'true' ? false : true}
                                            value={toPersianNumber((promotionPercent))}
                                            onChange={(e) => setPromtionPercentFunction(e)}
                                        />
                                        <span>درصد</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ height: '28px' }}></div>
                </React.Fragment>
        }
    }
    return (
        <React.Fragment>
            <Toast tag="errorToast" value={toast} text={toast} parentClose={() => setToast('')} />
            <Modal
                tag="edit"
                value={props.show ? true : false}
                title={props.list.length == 1 ? "ویرایش" : "ویرایش گروهی محصولات"}
                parentClose={closeModal}
                editModalButtonsPack={true}
                calculateLoading={calculateLoading}
                calculatePrice={calculatePrice}
                closeModal={() => closeModal("")}
                errors={errors}
                showConfirmButton={modalTabel.showConfirmButton}
                sendDataToParent={() => sendDataToParent("single")}
            >
                {loading ? <div className={style.priceLoading}><span>.</span><span>.</span><span>.</span></div> :
                    <div className={style.wrapper}>
                        <div className={style.editModalWrapper}>
                            {props.list.length == 1 ?
                                <div className={style.info}>
                                    <div className={style.rowOne}>
                                        <div className={style.name}>{toPersianNumber(modalData.newName)}</div>
                                    </div>
                                    <div className={style.rowOne}>
                                        <div className={style.group}>
                                            <p>{modalData.productGroup}</p>
                                            <label>
                                                : گروه
                                            </label>
                                        </div>
                                    </div>
                                    <div className={style.rowOne}>
                                        <div className={style.tax}>
                                            <p>{toPersianNumber(10) + "%"}</p>
                                            <label>
                                                :مالیات فروش
                                            </label>
                                        </div>

                                        <div className={style.comission}>
                                            <p>{toPersianNumber(modalData.platformPercent ? modalData.platformPercent.toFixed(2) : modalData.platformPercent) + "%"}</p>
                                            <label>
                                                :توسعه پلتفرم
                                            </label>
                                        </div>

                                        <div className={style.comission}>
                                            <p>{toPersianNumber(modalData.commission) + "%"}</p>
                                            <label>
                                                :کمیسیون فروش
                                            </label>
                                        </div>

                                        <div className={style.resourcePrice}>
                                            <label>
                                                : قیمت مرجع
                                            </label>
                                            <p>{modalData && modalData.resourcePrice && toPersianNumber(numberWithCommas(modalData.resourcePrice))} ریال </p>
                                        </div>

                                    </div>
                                    {modalData.newName !== modalData.name &&
                                        <div className={style.rowTwo}>
                                            <p>{toPersianNumber(modalData.name)}</p>
                                            <label>
                                                : نام اصلی کالا
                                            </label>
                                        </div>}
                                </div>
                                : <div className={style.info}>
                                    <div className={style.rowOne}>
                                        <p className={style.productCount}>.کالا انتخاب شده است</p>
                                        <p className={style.productCount}>{toPersianNumber(props.list.length)}</p>
                                    </div>
                                    <div className={style.rowOne}>
                                        <div className={style.groupTax}>
                                            <p>{toPersianNumber(10) + "%"}</p>
                                            <label>
                                                :مالیات فروش
                                            </label>
                                        </div>
                                        <div className={style.comission}>
                                            <p>{toPersianNumber(serverData.commission)}</p>
                                            <label>
                                                :کمیسیون فروش
                                            </label>
                                        </div>
                                        <div className={style.groups}>
                                            <label>
                                                :گروه
                                            </label>
                                            <p>{props.list.map((item, index) => {
                                                if (index < props.list.length - 1) {
                                                    return item.productGroup + ", "
                                                } else {
                                                    return item.productGroup
                                                }
                                            })}
                                            </p>
                                        </div>
                                    </div>
                                </div>}
                            {variantSizeWarning.variantHasSizeLoading ? <Skeleton type='rectangle' width='100%' height='38px' /> : variantSizeWarning.variantHasSize != '' ? <div className={style.yellowWarning}>
                                <span className={style.warningIcon}>h</span>
                                <p>{variantSizeWarning.variantHasSize}</p>
                            </div> : <div></div>}

                            <div className={style.tabsContainer}>
                                {/* <div className={tab === 'group' ? style.selectedTab : style.tab} onClick={() => setTab('group')}>گروه‌بندی</div> */}
                                <div className={tab === 'default' ? style.selectedTab : style.tab}
                                    onClick={() => setTab('default')}>تنظیمات پیش‌فرض
                                </div>
                                <div className={tab === 'primary' ? style.selectedTab : style.tab}
                                    onClick={() => setTab('primary')}>تنظیمات اولیه
                                </div>
                            </div>

                            <>
                                {modalContentGenerator()}
                                <div className={style.wrongMaximumPriceWrapper}>
                                    <span className={style.icon}>n</span>
                                    <div className={style.wrongMaximumPrice}>
                                        <p>قیمت‌ها به ریال می‌باشند.</p>
                                    </div>
                                </div>
                            </>

                            <div className={style.tabelWrapper} ref={tableRef}>
                                {modalTabel.open ?
                                    <Tabel
                                        data={{
                                            ...modalTabel.data,
                                            dkpc: modalData.DKPC,
                                            ancillaryCosts: typeof serverData.ancillaryCosts !== "undefined" && serverData.ancillaryCosts.toString()
                                        }}
                                        hasLeafCatPercent={modalData.hasLeafCatPercent}
                                        hasPlatforCosts={(serverData.platformCosts && typeof modalData.platformPercent != 'undefined') ? serverData.platformCosts : false}
                                        type={(serverData.platformCosts && typeof modalData.platformPercent != 'undefined') ? 'dk2' : 'dk'}
                                    />
                                    : null}
                            </div>
                        </div>
                    </div>
                }
            </Modal>
        </React.Fragment>
    )
}
export default EditModal